import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Homepage from './components/Homepage';
import MissionInterface from './components/MissionInterface';
import ThemeVoting from './components/ThemeVoting';
import './index.css';

function App() {
  const [currentView, setCurrentView] = useState('login');
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState('');

  // Set up global logout function that MissionInterface can call
  useEffect(() => {
    window.logout = () => {
      setCurrentView('login');
      setUserId(null);
      setUserName('');
    };
    
    return () => {
      delete window.logout;
    };
  }, []);

  const handleLogin = (id, name) => {
    setUserId(id);
    setUserName(name);
    setCurrentView('home');
  };

  const handleStartMission = () => {
    setCurrentView('mission');
  };

  const handleMissionComplete = () => {
    setCurrentView('voting');
  };

  const handleVotingComplete = () => {
    setCurrentView('thankyou');
  };

  return (
    <div className="min-h-screen">
      {currentView === 'login' && (
        <Login onLogin={handleLogin} />
      )}
      
      {currentView === 'home' && (
        <Homepage onStartRegistration={handleStartMission} />
      )}
      
      {currentView === 'mission' && userId && (
        <MissionInterface 
          userId={userId} 
          userName={userName}
          onComplete={handleMissionComplete} 
        />
      )}
      
      {currentView === 'voting' && (
        <ThemeVoting 
          userId={userId} 
          onComplete={handleVotingComplete} 
        />
      )}
      
      {currentView === 'thankyou' && (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="scanline"></div>
          <div className="bg-dark-lighter rounded-lg shadow-neon-green border border-primary/30 p-8 max-w-md text-center">
            <div className="text-6xl mb-4">✓</div>
            <h1 className="text-3xl font-bold text-primary mb-4 font-mono">
              [SUCCESS] MISSION_COMPLETE
            </h1>
            <p className="text-cyber-blue mb-6 font-mono">
              &gt;&gt; Data transmitted successfully<br/>
              &gt;&gt; Connection terminated<br/>
              &gt;&gt; Session cleared
            </p>
            <button
              onClick={() => {
                setCurrentView('login');
                setUserId(null);
                setUserName('');
              }}
              className="bg-primary text-dark px-6 py-3 rounded-lg hover:shadow-neon-green 
                       transition-all font-bold font-mono border-2 border-primary
                       hover:bg-transparent hover:text-primary"
            >
              [LOGOUT] TERMINATE_SESSION →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
